export default "__VITE_ASSET__BRvKiDmw__"